import './haddon/style';
import FormStructure from './haddon/form_structure';

export default FormStructure;